import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  RedditShareButton,
  RedditIcon,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';
import React, { useState, useContext } from 'react';
import styled from '@emotion/styled';
import { Button, PageContext } from 'gatsby-theme-apollo';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy } from 'react-icons/fa';


const iconSize = 32;

const StyledShareBar = styled.div`
  padding: 6px 6px;
  display: flex;
  border-radius: 5px 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  div {
    margin: 0px 1px;

    .social-icon {
      box-sizing: border-box;
      border: 1px solid transparent;
      border-radius: 5px;
      :hover {
        border: 1px solid white;
      }
    }
  }
`;

const ShareBar = ({ location }) => {
  const [copied, setCopied] = useState(false);
  const { logEvent } = useContext(PageContext);
  const currentHREF = typeof window !== 'undefined' ? window.location.href : '';
  const currentSearch = typeof window !== 'undefined' ? window.location.search : '';

  const currentURL = currentHREF.replace(currentSearch, '');

  const baseShareURL = `${currentURL}?utm_medium=social&utm_campaign=gh_share`;
  const fbShareURL = `${baseShareURL}&utm_source=facebook`;
  const redditShareURL = `${baseShareURL}&utm_source=reddit`;
  const twitterShareURL = `${baseShareURL}&utm_source=twitter`;
  const whatsappShareURL = `${baseShareURL}&utm_source=whatsapp`;
  const linkShareURL = `${baseShareURL}&utm_source=link`;

  return (
    <StyledShareBar>
      <FacebookShareButton
        url={fbShareURL}
        beforeOnClick={() => {
          logEvent('share_link', { networkName: 'Facebook', location, currentURL });
        }}
      >
        <FacebookIcon size={iconSize} borderRadius={7} />
      </FacebookShareButton>
      <TwitterShareButton
        url={twitterShareURL}
        beforeOnClick={() => {
          logEvent('share_link', { networkName: 'Twitter', location, currentURL });
        }}
      >
        <TwitterIcon size={iconSize} borderRadius={7} />
      </TwitterShareButton>
      <RedditShareButton
        url={redditShareURL}
        beforeOnClick={() => {
          logEvent('share_link', { networkName: 'Reddit', location, currentURL });
        }}
      >
        <RedditIcon size={iconSize} borderRadius={7} />
      </RedditShareButton>
      <WhatsappShareButton
        url={whatsappShareURL}
        beforeOnClick={() => {
          logEvent('share_link', { networkName: 'Whatsapp', location, currentURL });
        }}
      >
        <WhatsappIcon size={iconSize} borderRadius={7} />
      </WhatsappShareButton>

      <CopyToClipboard text={linkShareURL} onCopy={() => setCopied(true)}>
        <Button
          primary
          style={{ padding: `3px 6px` }}
          onClick={() => {
            logEvent('share_link', { networkName: 'Link', location, currentURL });
          }}
        >
          <FaCopy />
          <span>{copied ? 'Link Copied' : 'Copy Link'}</span>
        </Button>
      </CopyToClipboard>
    </StyledShareBar>
  );
};

export default ShareBar;
